import { createAction } from '../../store/createAction';

export const requestSuccessful = createAction(
    'request/REQUEST_SUCCESS',
    (id: string, response: unknown) => ({
        id,
        response,
    }),
);
